export interface IAppGlobalSettings extends IBaseAppGlobalSettings {
	_id: string;

}

export interface IUpdateAppGlobalSettings extends IBaseAppGlobalSettings {
	_id: string;
}

export interface ICreateAppGlobalSettings extends IBaseAppGlobalSettings {}

export interface IBaseAppGlobalSettings {
	setting_key: 'global';

	// Profile/Avatar Settings
	profile: {
		gravatar: IGravatarSettings
	};

	createdAt?: Date;
	updatedAt?: Date;
}

export interface IGravatarSettings {
	enabled: boolean;
}

// Default settings (used for initialization)
export const DEFAULT_GLOBAL_SETTINGS: Omit<IAppGlobalSettings, '_id' | 'createdAt' | 'updatedAt'> = {
	setting_key: 'global',
	profile: {
		gravatar: {
			enabled: false
		}
	}
};
